// src/App.jsx
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";

import Leftbar from "./components/Leftbar";
import Dashboard from "./pages/Dashboard";

import { SocketProvider } from "./service/SocketProvider";

import "./App.css";

import AddAlert from "./pages/Alerts/AddAlert";
import Alerts from "./pages/Alerts/Alerts";
import EditAlert from "./pages/Alerts/EditAlert";
import Chat from "./pages/Chat";
import Chats from "./pages/Chats";
import PersonalChat from "./pages/PersonalChat";
import PersonalChats from "./pages/PersonalChats";
import AddContact from "./pages/Contacts/AddContact";
import Contacts from "./pages/Contacts/Contacts";
import EditContact from "./pages/Contacts/EditContact";
import AddCourse from "./pages/Courses/AddCourse";
import Courses from "./pages/Courses/Courses";
import EditCourse from "./pages/Courses/EditCourse";

import Users from "./pages/Users/Users";

import Details from "./pages/Inbox/Details";
import Inbox from "./pages/Inbox/Inbox";
import Profile from "./pages/Profile";
// import OldChats from "./pages/OldChats/Chats";

const App = () => {
  return (
    <SocketProvider>
      <Router>
        {/* <Navbar /> */}
        <Routes>
          <Route>
            <Route path="/" element={<Login />} />
            <Route path="/signin" element={<Login />} />
            <Route path="/*" element={<NotFound />} />
          </Route>

          <Route element={<Leftbar />}>
            <Route path="/dashboard" element={<Dashboard />} />

            <Route path="/chat" element={<Chats />} >
              <Route path="/chat/:id" element={<Chat />} />
            </Route>

            <Route path="/personal-chat" element={<PersonalChats />}>
              <Route path="/personal-chat/:id" element={<PersonalChat />} />
            </Route>

            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/add" element={<AddCourse />} />
            <Route path="/courses/edit/:id" element={<EditCourse />} />

            <Route path="/users" element={<Users />} />

            <Route path="/contacts" element={<Contacts />} />
            <Route path="/contacts/add" element={<AddContact />} />
            <Route path="/contacts/edit/:id" element={<EditContact />} />

            <Route path="/alerts" element={<Alerts />} />
            <Route path="/alerts/add" element={<AddAlert />} />
            <Route path="/alerts/edit/:id" element={<EditAlert />} />

            <Route path="/inbox" element={<Inbox />} />
            <Route path="/inbox/:id" element={<Details />} />

            <Route path="/profile" element={<Profile />} />

            {/* <Route path="/old-chats" element={<OldChats />} /> */}

          </Route>
        </Routes>
      </Router>
    </SocketProvider>
  );
};

export default App;
